module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_average.724c9f8b.png";